import GuestyIntegration from './GuestyIntegration';

export default GuestyIntegration;
